import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { getTheme } from '../../global/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

const BcItem = styled.li`
  list-style: none;
  display: flex;
  align-items: center;
  margin-right: ${getTheme('spacer', 's')};

  a {
    text-decoration: none;
    display: flex;
    padding-right: ${getTheme('spacer', 's')};
  }

  .bc-item__icon {
    margin-right: ${getTheme('spacer', 'xs')};
    color: ${getTheme('textColor', 'disabled')};
  }
  .bc__next {
    color: ${getTheme('textColor', 'disabled')};
  }
`

class BreadcrumbItem extends Component {
  render() {
    return (
      <BcItem>
        <Link to={this.props.url}>
          <div className="bc-item__icon">{this.props.icon}</div>
          {this.props.text}
        </Link>
        <FontAwesomeIcon icon={faArrowRight} className="bc__next" />
      </BcItem>
    )
  }
}

export default BreadcrumbItem



// WEBPACK FOOTER //
// ./src/components/navs/BreadcrumbItem.js